module.exports = __webpack_public_path__ + "media/investors/cta-d794f19f.jpg";